import React from "react";
import { connect } from "react-redux";
import { permissionActions, userActions, notificationActions, chatActions, inventoryActions } from "../_actions";
import InventoryAlertModal from "../common/InventoryAlertModal";
import PropTypes from "prop-types";
import {
  ProfileHeader,
  TabNavigation,
  TabContent,
} from '../common/Profile';
import Modal from 'react-responsive-modal';
import ReactModal from 'react-modal';
import NewModal from 'react-responsive-modal';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import { AlertPopup } from '../_components/AlertPopup';
import { authHeader, config } from '../_helpers';
import { dateTimeConstants } from '_constants';
import { profileService } from '_services/profile.service';
import { handleErrorResponse } from '_helpers/helpers';

ReactModal.setAppElement('#app');

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hash: this.props?.hash?.split("/")[2],
      tab: 'profile',
      request_rehire_doc: false,
      request_rehire_doc_status: false,
      doc_request: '',
      sendingDDForm: false,
      reloadKey: 0,
      // Modal states
      statusOpen: false,
      removeOpen: false,
      archiveStep: '3a',
      alertOpen: false,
      mailSendOpen: false,
      send_dd_form_confirm: false,
      // Status modal states
      requireDocs: false,
      sendEmail: 1,
      sms: 1,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      message: '',
      notes: '',
      alertPop: false,
      userName: '',
      afterSuccess: false,
      inventoryUserAlert: false,
      isGuest: false,
      unavailableReason: 0,
      reasonToDisplay: 0,
      unavailableErr: '',
      unavailableDescriptionErr: '',
      otherReason: '',
      displayOtherReason: '',
      savingNote: false,
      active: 1,
      lastDayWorked: moment(),
      lastDayReason: '',
      lastDayReasonErr: '',
      loader: false,
    };
    this.goBack = this.goBack.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.print = this.print.bind(this);
    this.mailSendOpenModal = this.mailSendOpenModal.bind(this);
    this.mailSendCloseModal = this.mailSendCloseModal.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.handleRemoveEmployee = this.handleRemoveEmployee.bind(this);
    this.handleLockProfile = this.handleLockProfile.bind(this);
    this.removeCloseModal = this.removeCloseModal.bind(this);
    this.openDdformConfirmModal = this.openDdformConfirmModal.bind(this);
    this.ddFormConfirmCloseModal = this.ddFormConfirmCloseModal.bind(this);
    this.documentRequest = this.documentRequest.bind(this);
    this.downloadAllDocuments = this.downloadAllDocuments.bind(this);
    this.downloadAllDocumentsAsPDF = this.downloadAllDocumentsAsPDF.bind(this);
    this.docRequestModalClose = this.docRequestModalClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.sendDDForm = this.sendDDForm.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.changeUnavailabilityReason = this.changeUnavailabilityReason.bind(this);
    this.changeLastDayReason = this.changeLastDayReason.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.setStep = this.setStep.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.lockProfile = this.lockProfile.bind(this);
    this.unlockProfile = this.unlockProfile.bind(this);
    this.requireDocs = this.requireDocs.bind(this);
    this.remove = this.remove.bind(this);
    this.collectLastDayWorked = this.collectLastDayWorked.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleLastDayChange = this.handleLastDayChange.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(permissionActions.getPermission());
    const hash = "?hash=" + this.state.hash;
    this.props.dispatch(userActions.getProfile(hash));
    this.props.dispatch(chatActions.getConversationSettings());
    
    // Load inventory data for inventory check
    let data = new FormData();
    data.append('hash', this.state.hash);
    this.props.dispatch(inventoryActions.getInventoryList(data));
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;

    if (user?.lockProfileSuccess && !prevProps.user?.lockProfileSuccess) {
      this.statusCloseModal();
      toast.success('Profile updated successfully');
      this.setState({
        reloadKey: this.state.reloadKey + 1,
        lastDayReason: '',
        lastDayWorked: moment(),
        loader: false,
      });
    }

    if (user?.lockProfileFailure && !prevProps.user?.lockProfileFailure) {
      this.statusCloseModal();
      toast.error('Failed to update profile');
      this.setState({ loader: false });
    }

    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user, permission } = nextProps;
    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;

      this.setState({
        permList,
      });
    }
    if (user.items) {
      const profile = user.items.data;
      const available = profile.active === 'Available' ? true : false;
      this.setState({
        active: profile.active,
        status: profile.active,
        is_locked: profile.is_locked,
        available: available,
        notes: this?.state?.notes ? this?.state?.notes : profile.notes,
        profile,
        hash: profile.hash,
        userName: profile.first_name,
        user_type: user.items.data.user_type,
        resource_id: user.items.data.crew_identifier_id,
        isGuest: user.items.data.status === 3 ? true : false,
        reasonToDisplay: user.items.data.unavailable_reason,
        displayOtherReason: user.items.data.other_reason,
      });
    }

    if (user.removeUser) {
      if (user.removeUser.success) {
        this.setState({
          alertHead: 'Success',
          alertMsg: user.removeUser.message,
          removeOpen: false,
          archiveStep: '3a',
          alertOpen: true,
        });
      } else {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: user.removeUser.message,
          alertFunction: '',
          archiveStep: '3a',
          removeOpen: false,
        });
      }
    }
  }

  goBack() {
    this.props.goBack(this.props.resourceDetails);
  }

  changeTab(tab) {
    this.setState({ tab });
  }

  print() {
    window.print();
  }

  mailSendOpenModal() {
    this.setState({ mailSendOpen: true, message: '', sendEmail: 1, sms: 1 });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({
      statusOpen: false,
      unavailableReason: 0,
      unavailableErr: '',
      unavailableDescriptionErr: '',
      otherReason: '',
    });
    let doc = document.querySelector('html');
    doc.style.overflow = '';
    doc.style.position = '';
    doc.style.width = '';
    doc.style.top = '';
  }

  handleRemoveEmployee(e) {
    let inventoryList = this.props.inventory?.inventory?.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'remove', statusOpen: false });
    } else {
      this.setState({ removeOpen: true });
    }
  }

  handleLockProfile(e) {
    let inventoryList = this.props.inventory?.inventory?.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'lock', statusOpen: false });
    } else {
      this.setStep('1b');
    }
  }

  removeCloseModal() {
    this.setState({ removeOpen: false, archiveStep: '3a' });
  }

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  ddFormConfirmCloseModal() {
    this.setState({
      send_dd_form_confirm: false,
    });
  }

  documentRequest(hash, doc_request) {
    this.setState({ doc_request });
    // Implement document request functionality if needed
    console.log('Document request not implemented for YourCrew');
  }

  downloadAllDocuments(event, rehire = false, giss = false) {
    // Implement download functionality if needed
    console.log('Download documents not implemented for YourCrew');
  }

  downloadAllDocumentsAsPDF(event, rehire = false, giss = false) {
    // Implement PDF download functionality if needed
    console.log('Download PDF not implemented for YourCrew');
  }

  docRequestModalClose() {
    this.setState({ request_rehire_doc: false });
  }

  handleChange(event) {
    if (event.target.name === 'notes') {
      if (this.state.permList.includes('Employee Notes')) {
        this.setState({
          [event.target.name]: event.target.value,
          template: 'custommail',
        });
      }
      return;
    }
    this.setState({
      [event.target.name]: event.target.value,
      template: 'custommail',
    });
  }

  handleCheckbox(e) {
    const { name } = e.target;
    this.setState({
      [name]: e.target.checked ? 1 : 0,
    });
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    const emailVal = this.state.sendEmail ? 1 : 0;
    const smsVal = this.state.sms ? 1 : 0;
    data.append('type', 'mail');
    data.append('email', emailVal);
    data.append('sms', smsVal);
    data.append('message', this.state.message);
    data.append('user_hash', hash);
    const self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  sendDDForm() {
    if (this.props.user.items.data.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.props.user.items.data.hash);
      profileService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  changeUnavailabilityReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      unavailableDescriptionErr: '',
      unavailableErr: '',
    });
    e.target.setAttribute('errors', '');
  };

  changeLastDayReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      lastDayReasonErr: '',
    });
  };

  setStatusReturn(status) {
    if (Number(this.state.unavailableReason) === Number(0)) {
      this.setState({
        unavailableErr: 'error',
      });
      return;
    }
    if (!this.state.otherReason.trim()) {
      this.setState({
        unavailableDescriptionErr: 'error',
      });
      return;
    }

    let step;
    if (status) {
      step = '2a';
      this.setState({
        returnDate: moment().format(dateTimeConstants.DATE_FORMAT),
      });
    } else {
      step = '2b';
      this.setState({
        returnDate: '',
      });
    }
    this.setState({
      statusStep: step,
    });
  }

  setStep(step) {
    this.setState({ statusStep: step });
  }

  changeStatus(status) {
    if (status) {
      let stat = this.state.status === 'Available' ? 'Unavailable' : 'Available';
      const hash = '?hash=' + this.state.hash;
      let data = new FormData();
      data.append('end_date', this.state.returnDate);
      data.append('hash', this.state.hash);
      data.append('status', stat);
      data.append(
        'unavailableReason',
        this.state.unavailableReason ? this.state.unavailableReason : 0,
      );
      data.append(
        'otherReason',
        this.state.otherReason ? this.state.otherReason : '',
      );

      this.props.dispatch(userActions.changeStatus(data, hash));
      this.props.dispatch(notificationActions.getCount());
      this.setState({ status: stat, active: stat, loader: true });
    }
  }

  lockProfile() {
    if (!this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    let stat = 'Locked';
    const hash = '?hash=' + this.state.hash;
    let data = new FormData();

    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(
        dateTimeConstants.ISO_DATE_FORMAT,
      ),
    );
    data.append('modify_active_status', true);
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  requireDocs(e) {
    this.setState({ requireDocs: e.target.checked });
  }

  unlockProfile() {
    let stat = 'Unlocked';
    const hash = '?hash=' + this.state.hash;
    let data = new FormData();
    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append('document', this.state.requireDocs);
    data.append('modify_active_status', true);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  remove() {
    if (!this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', this.state.hash);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(
        dateTimeConstants.ISO_DATE_FORMAT,
      ),
    );
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.removeEmployee(data));
  }

  collectLastDayWorked() {
    this.setState({ archiveStep: '3b' });
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  handleLastDayChange(date) {
    if (date) {
      this.setState({
        lastDayWorked: date,
      });
    }
  }

  render() {
    const { permission } = this.props;
    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }

    const authUser = this.props.user.profile?.data ?? {};
    const userData = this.props.user.items?.data ?? {};

    return (
      <div className="resource_container profile_container">
        <ProfileHeader
          profile={this.state.profile}
          resourceId={this.state.hash}
          activeTab={this.state.tab}
          hash={this.state.hash}
          permList={permList}
          authUser={authUser}
          userData={userData}
          sendingDDForm={this.state.sendingDDForm}
          requestRehireDoc={this.state.request_rehire_doc}
          docRequest={this.state.doc_request}
          requestRehireDocStatus={this.state.request_rehire_doc_status}
          onToResourceList={this.goBack.bind(this)}
          onPrint={this.print.bind(this)}
          onMailSendOpen={this.mailSendOpenModal.bind(this)}
          onStatusOpen={this.statusOpenModal.bind(this)}
          onRemoveEmployee={this.handleRemoveEmployee.bind(this)}
          onDdFormConfirmOpen={this.openDdformConfirmModal.bind(this)}
          onDocumentRequest={this.documentRequest.bind(this)}
          onDownloadAllDocuments={this.downloadAllDocuments.bind(this)}
          onDownloadAllDocumentsAsPDF={this.downloadAllDocumentsAsPDF.bind(this)}
          onDocRequestModalClose={this.docRequestModalClose.bind(this)}
          breadcrumbType="yourcrew"
        />
        
        <TabNavigation
          activeTab={this.state.tab}
          permList={permList}
          hasApplicantHash={!!this.state.profile?.applicant_hash}
          onChangeTab={this.changeTab.bind(this)}
        />
        
        <TabContent
          activeTab={this.state.tab}
          hash={this.state.hash}
          permList={permList}
          reloadKey={this.state.reloadKey}
          authUser={this.props?.user?.profile?.data || {}}
          userData={this.props?.user?.items?.data}
          applnType={this.state.applnType}
          email={this.props?.user?.items?.data?.email_address ?? ''}
          onSendMail={this.sendMail}
          onViewHistory={() => {}}
          onViewDetails={() => {}}
          onGoBack={() => {}}
        />

        {/* Status modal */}
        <NewModal
          id='status_popup'
          classNames={{ modal: 'status_popup' }}
          open={this.state.statusOpen}
          onClose={this.statusCloseModal.bind(this)}
          overlayClassName='empStatusPopup resEmpStatusPop profileEmp_status_modal'
          className='status_popup'
          center
        >
          <div id='statusPopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Current Status</h4>
            </div>
            {this.state.statusStep === '1' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <label>
                    {this.state.profile?.first_name +
                      ' ' +
                      this.state.profile?.last_name +
                      ' is: '}
                    <span className='green'>{this.state.status}</span>
                  </label>
                  <br />
                  <div className='user-status-edit-wrapper'>
                    <div>
                      {this.state.is_locked === 0 && (
                        <button
                          className='button'
                          onClick={this.handleLockProfile.bind(this)}
                        >
                          Lock Profile
                        </button>
                      )}
                      {this.state.is_locked === 1 && (
                        <button
                          className='button'
                          onClick={this.setStep.bind(this, '1a')}
                        >
                          Unlock Profile
                        </button>
                      )}
                    </div>
                    <div>
                      <button
                        className={`button outlined ${
                          this.state.is_locked === 1 ? 'disabled' : ''
                        }`}
                        onClick={this.setStep.bind(this, '2')}
                        disabled={this.state.is_locked === 1}
                      >
                        {this.state.status === 'Available'
                          ? 'Make Unavailable'
                          : 'Make Available'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '1a' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <section className='d-flex flex-column checkb'>
                    <h6 className='text-bold'>
                      Are you sure you want to Unlock the selected employee
                    </h6>
                    {(userData.docs_status === -1 ||
                      userData.rehire_docs_status === -1) && (
                      <label>
                        <input
                          type='checkbox'
                          onChange={this.requireDocs}
                          defaultChecked={this.state.requireDocs}
                        />
                        <span>Ask to fill Documents</span>
                      </label>
                    )}
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button disabled'
                        onClick={this.setStep.bind(this, '2')}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button'
                        onClick={this.unlockProfile}
                      >
                        Unlock
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '1b' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <section className='d-flex flex-column checkb'>
                    <p>
                      Are you sure you want to Lock the selected employee ?
                    </p>
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        className='button grey'
                        onClick={this.setStep.bind(this, '2')}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        className='button'
                        onClick={this.setStep.bind(this, '1c')}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '1c' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <section className='d-flex flex-column checkb'>
                    <div classNames='full-width'>
                      <p>Last Day Worked</p>
                      <DatePicker
                        className='lastDayWorked'
                        name='lastDayWorked'
                        selected={this.state.lastDayWorked}
                        onChange={this.handleLastDayChange.bind(this)}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                      />
                      <textarea
                        rows='3'
                        maxLength={1200}
                        className='lastDayReason'
                        value={this.state.lastDayReason}
                        name='lastDayReason'
                        onChange={this.changeLastDayReason}
                        errors={this.state.lastDayReasonErr}
                      />
                    </div>
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button grey'
                        onClick={this.setStep.bind(this, '2')}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button'
                        onClick={this.lockProfile}
                      >
                        Lock
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '2' && this.state.available && (
              <div className='modal-body'>
                <div className='status_step step2'>
                  <label>Reason for Unavailability: </label>
                  <select
                    name='unavailableReason'
                    className='unavailability_reason'
                    value={this.state.unavailableReason}
                    onChange={this.changeUnavailabilityReason}
                    errors={this.state.unavailableErr}
                  >
                    <option value='0'>-- Select Reason --</option>
                    <option value='1'>Time Off</option>
                    <option value='2'>Sick</option>
                    <option value='3'>Injury</option>
                    <option value='4'>Other</option>
                  </select>
                  {(this.state.unavailableReason === '1' ||
                    this.state.unavailableReason === '2' ||
                    this.state.unavailableReason === '3' ||
                    this.state.unavailableReason === '4') && (
                    <div classNames='full-width'>
                      <textarea
                        rows='3'
                        maxLength={1200}
                        className='other_reason'
                        value={this.state.otherReason}
                        name='otherReason'
                        onChange={this.changeUnavailabilityReason}
                        errors={this.state.unavailableDescriptionErr}
                      />
                    </div>
                  )}
                  <label>
                    Do you know when {this.state.userName} will return?
                  </label>
                  <button
                    className='button'
                    onClick={this.setStatusReturn.bind(this, true)}
                  >
                    Yes
                  </button>
                  <button
                    className='button grey'
                    onClick={this.setStatusReturn.bind(this, false)}
                  >
                    No
                  </button>
                  <p className='step_no'>2/3</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '2' && !this.state.available && (
              <div className='modal-body'>
                <div className='status_step step2'>
                  <label>
                    Are you sure you want to make the employee available?
                  </label>
                  <button
                    disabled={this.state.loader}
                    className='button'
                    onClick={this.changeStatus.bind(this, true)}
                  >
                    Yes
                  </button>
                  <button
                    disabled={this.state.loader}
                    className='button grey'
                    onClick={this.statusCloseModal.bind(this)}
                  >
                    No
                  </button>
                  <p className='step_no'>2/2</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '2a' && (
              <div className='modal-body'>
                <div className='status_step step4'>
                  <label>Choose date of return:</label>
                  <DatePicker
                    className='returnDateField'
                    name='returnDateField'
                    selected={this.state.returnDateField}
                    onChange={this.handleDateChange.bind(this)}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    minDate={moment()}
                  />
                  <button
                    className='button btn_margin'
                    onClick={this.setStep.bind(this, '3')}
                  >
                    Next
                  </button>
                  <p className='step_no'>2/3</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '2b' && (
              <div className='modal-body'>
                <div className='status_step step2'>
                  <label>
                    Are you sure you want to make the employee unavailable?
                  </label>
                  <button
                    disabled={this.state.loader}
                    className='button'
                    onClick={this.changeStatus.bind(this, true)}
                  >
                    Yes
                  </button>
                  <button
                    disabled={this.state.loader}
                    className='button grey'
                    onClick={this.statusCloseModal.bind(this)}
                  >
                    No
                  </button>
                  <p className='step_no'>3/3</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '3' && (
              <div className='modal-body'>
                <div className='status_step step5'>
                  <label>
                    Are you sure you want to switch {this.state.userName} to
                    Unavailable?
                  </label>
                  <p>
                    (returning{' '}
                    {this.state.returnDate === ''
                      ? moment().format('MM/DD/YYYY')
                      : this.state.returnDate}
                    )
                  </p>
                  <button
                    className='button'
                    onClick={this.changeStatus.bind(this, true)}
                  >
                    Yes
                  </button>
                  <button
                    className='button grey'
                    onClick={this.statusCloseModal.bind(this)}
                  >
                    No
                  </button>
                  <p>Time off must be approved by your supervisor.</p>
                  <p className='step_no'>3/3</p>
                </div>
              </div>
            )}
          </div>
        </NewModal>

        {/* Remove Employee Modal */}
        <NewModal
          id='remove_popup'
          className='status_popup'
          open={this.state.removeOpen}
          onClose={this.removeCloseModal.bind(this)}
          little
        >
          <div id='removePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>
                Remove Employee:{' '}
                {this.state.profile
                  ? this.state.profile.first_name +
                    ' ' +
                    this.state.profile.last_name
                  : ''}
              </h4>
            </div>
            <div className='modal-body'>
              {this.state.archiveStep == '3a' && (
                <div>
                  <label>
                    Are you sure you want to archive this employee?
                  </label>
                  <br />
                  <button
                    className='button grey'
                    onClick={this.removeCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.collectLastDayWorked.bind(this)}
                  >
                    Archive
                  </button>
                </div>
              )}

              {this.state.archiveStep == '3b' && (
                <div className='status_step step1'>
                  <section
                    className='d-flex flex-column checkb'
                    style={{ padding: '10px' }}
                  >
                    <div classNames='full-width'>
                      <p>Last Day Worked</p>
                      <DatePicker
                        className='lastDayWorked'
                        name='lastDayWorked'
                        selected={this.state.lastDayWorked}
                        onChange={this.handleLastDayChange.bind(this)}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                      />
                      <textarea
                        rows='3'
                        maxLength={1200}
                        className='lastDayReason'
                        value={this.state.lastDayReason}
                        name='lastDayReason'
                        onChange={this.changeLastDayReason}
                        errors={this.state.lastDayReasonErr}
                      />
                    </div>
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button grey'
                        onClick={this.removeCloseModal.bind(this)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button'
                        onClick={this.remove.bind(this)}
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </NewModal>

        <InventoryAlertModal
          isOpen={this.state.inventoryUserAlert}
          onClose={() => this.setState({ inventoryUserAlert: false })}
          action={this.state.inventoryAlertAction || 'remove'}
          userHash={this.state.hash}
        />

        {/* Direct Deposit Form Modal */}
        <Modal
          id='remove_popup'
          className='status_popup'
          open={this.state.send_dd_form_confirm}
          onClose={this.ddFormConfirmCloseModal.bind(this)}
          little
        >
          <div id='removePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Direct Deposit Form</h4>
            </div>
            <div className='modal-body'>
              <label>
                This will send an email to{' '}
                {this.state.profile
                  ? this.state.profile.first_name +
                    ' ' +
                    this.state.profile.last_name
                  : 'this employee'}
                , with Direct Deposit form link.
              </label>
              <br />
              <button
                className='button grey'
                onClick={this.ddFormConfirmCloseModal.bind(this)}
              >
                Cancel
              </button>
              <button className='button' onClick={this.sendDDForm.bind(this)}>
                Send
              </button>
            </div>
          </div>
        </Modal>

        {/* Message Modal */}
        <Modal
          id='email_popup'
          className='status_popup'
          open={this.state.mailSendOpen}
          onClose={this.mailSendCloseModal.bind(this)}
          little
        >
          <div id='emailPopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Custom Message</h4>
            </div>
            <div className='modal-body'>
              <div className='cust_email_options'>
                <div className='option_email'>
                  <input
                    type='checkbox'
                    name='sendEmail'
                    checked={!!this.state.sendEmail}
                    onChange={this.handleCheckbox}
                  />
                  <span>Email</span>
                  <div className='clearfix' />
                </div>
                <div className='option_sms'>
                  <input
                    type='checkbox'
                    name='sms'
                    checked={!!this.state.sms}
                    onChange={this.handleCheckbox}
                  />
                  <span>SMS</span>
                  <div className='clearfix' />
                </div>
              </div>
              <textarea
                name='message'
                cols='80'
                rows='10'
                value={this.state.message}
                onChange={this.handleChange.bind(this)}
              />

              <p className='step_no'>
                Signature will automatically be included.
              </p>

              <button
                className='button grey'
                onClick={this.mailSendCloseModal.bind(this)}
              >
                Cancel
              </button>
              <button
                className='button'
                onClick={this.sendMail.bind(this, this.state.hash)}
              >
                Send
              </button>
            </div>
          </div>
        </Modal>

        {/* Success/Error Alert Modal */}
        <ReactModal
          isOpen={this.state.alertOpen}
          onClose={() => this.setState({ alertOpen: false })}
          contentLabel='Alert Modal'
          overlayClassName='alertPopup'
        >
          <div id='statusPopup' className='popupModal'>
            <div className='modal-head'>
              <h4 className='modal-title'>{this.state.alertHead}</h4>
            </div>
            <div className='modal-body'>
              <p>{this.state.alertMsg}</p>
              <div className='btn_list'>
                <button
                  className='button'
                  onClick={() => this.setState({ alertOpen: false })}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </ReactModal>

        {/* Alert Popup */}
        {this.state.alertPop && (
          <AlertPopup
            head={this.state.alertHead}
            message={this.state.alertMsg}
            alertFunction={this.state.alertFunction}
            close={this.closeAlert.bind(this)}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user, permission, inventory, chat } = state;
  return {
    user,
    permission,
    inventory,
    chat,
  };
}

const connectedRegisterPage = connect(mapStateToProps)(Profile);
export { connectedRegisterPage as Profile };

Profile.propTypes = {
  hash: PropTypes.string,
  goBack: PropTypes.func,
  resourceDetails: PropTypes.any,
  user: PropTypes.object,
  permission: PropTypes.object,
  inventory: PropTypes.object,
  chat: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
};
